import IAppStore from "app/IAppStore";
import * as _ from "lodash";
import { useSelector } from "react-redux";
import FuturesContractPrice from "./futuresContractPrice";
import useContractsSubscription from "./useContractsSubscription";

export default function usePriceUpdates<T>(
    vals: T[], 
    getSymbol: (val: T) => string, 
    reducer: (val: T, update: FuturesContractPrice) => T) {
    
    useContractsSubscription(vals.map(m => getSymbol(m)));
    const updates = useSelector((m: IAppStore) => m.futuresContractPrices);

    return vals.map(m => {
        const update = updates[getSymbol(m)];
        return update == null ? m : reducer(m, update);
    });
}